/**
 * Unités de mesure par défaut.
 * Référence : document 04 § 5.4 (`units`) — codes alignés sur la colonne `code`.
 */
export const DEFAULT_UNITS = [
    { code: 'U', label: 'Unité', decimals: 2 },
    { code: 'FORFAIT', label: 'Forfait', decimals: 2 },
    { code: 'H', label: 'Heure', decimals: 2 },
    { code: 'J', label: 'Jour', decimals: 2 },
    { code: 'M2', label: 'Mètre carré', decimals: 2 },
    { code: 'ML', label: 'Mètre linéaire', decimals: 2 },
    { code: 'M3', label: 'Mètre cube', decimals: 2 },
    { code: 'KG', label: 'Kilogramme', decimals: 3 },
    { code: 'L', label: 'Litre', decimals: 2 },
    { code: 'KM', label: 'Kilomètre', decimals: 2 },
];
export const UNIT_DECIMALS_MIN = 0;
export const UNIT_DECIMALS_MAX = 4;
//# sourceMappingURL=units.constants.js.map